// extracted by mini-css-extract-plugin
export default {"events":"Events_events__1NbK9","events__list":"Events_events__list__l+fZ9"};